require("bootstrap-daterangepicker/daterangepicker.css");

import 'bootstrap-daterangepicker';

function enableDateFields($scope) {
  function clearDate(event) {

    // don't submit the form.
    event.preventDefault();

    // find a bunch of relevant elements.
    var $dateField = $(event.target).closest('.date-input').find('input');

    // clear the cloudinary id.
    $dateField.val(null);

  }

  $scope.find('input.single-daterange-with-time').each(function() {
    const $input = $(this);
    if ($input.data('daterangepicker')) return;

    const isPastOnly = $input.hasClass('past-only');
    $input.daterangepicker({
      singleDatePicker: true,
      timePicker: true,
      maxDate: isPastOnly ? new Date() : undefined,
      minDate: isPastOnly ? '01/01/2020' : undefined,
      showDropdowns: isPastOnly,
      locale: {
        cancelLabel: 'Clear',
        format: 'DD/MM/YYYY HH:mm',
      }
    });
  });

  $scope.find('input.single-daterange-with-time').on('apply.daterangepicker', function(ev, picker) {
    $(this).val(picker.startDate.format('DD/MM/YYYY HH:mm'));
  });

  $scope.find('input.single-daterange-with-time').on('cancel.daterangepicker', function(ev, picker) {
    $(this).val('');
  });

  $scope.find(".date-input button.clear").click(clearDate);
}

$(document).on('turbolinks:load', function() {
  enableDateFields($('body'));
})

$(document).on('sprinkles:update', function(event) {
  enableDateFields($(event.target));
})
